// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/dashboard.scss
// module id = 38
// module chunks = 0